import React from "react";
import CommonUtil from "../common/CommonUtil";
import i18next from 'i18next';
import _ from 'lodash';
import { VIEW , ViewKeys, USER_TYPE} from "../common/Foundation";
import MemberServices from "../services/MemberService";
import AccountAction from "./AccountAction";

export default class SettingActions {
    static translate(key) {
        return i18next.t(key)
    }

    static changeLocale (lang, canUpdate) {
        if (!lang) {
            return;
        }
        const path = window.location.pathname + window.location.search;
        if (lang.indexOf('alang_') >= 0) {
            lang = lang.replace("alang_", "");
        } else if (lang.indexOf("i_lang_") >= 0){
            lang = lang.replace("i_lang_", "");
        }
        if (canUpdate) {
            MemberServices.updateLocale(CommonUtil.toLocaleCode(lang)).then(res => {
            }).catch(err => {
                console.warn("Error change language:", err)
            });
        }
        return this.changePath(path, lang)
    }

    static changePath (path, lang) {
        CommonUtil.saveUserData('locale', CommonUtil.toLocaleCode(lang));
        const currentLanguague =  CommonUtil.getCurrentLang();
        return path == '/' + currentLanguague ? 
            path.replace('/' + currentLanguague, '/' + lang) :
            path.replace('/' + currentLanguague + '/', '/' + lang + '/');
    }

    static changeDisplayMode (displayMode, auth){
        const userData = {
            displayMode: displayMode === 'LIGHT' ? 'DARK' :  'LIGHT'
        }
        localStorage.setItem('themeMode', userData.displayMode);
        if (auth){
            MemberServices.updateDisplayMode(userData.displayMode).then(res => {
            }).catch(err => {
                console.warn("Error change display mode:", err)
            });
        }
        return userData
    }

    static updateDefaultView(view){
        MemberServices.updateDefaultView(view).then(res => {
            if (res){
                // CommonUtil.saveUserData('view', view);
            }
        });
    }

    static handleChangeRegional(event) {
        const view = event.target.id
        const currentLanguage = CommonUtil.getCurrentLang()
        if (view != null) {
            if (view.includes('asian')) {
                CommonUtil.saveLastViewByLoginId(VIEW.ASIAN);
                window.location.href = `/${currentLanguage}${AccountAction.getViewPath(VIEW.ASIAN)}/sports`;
                return
            }

            if (view.includes('compact')) {
                CommonUtil.saveLastViewByLoginId(VIEW.COMPACT);
                window.location.href = `/${currentLanguage}${AccountAction.getViewPath(VIEW.COMPACT)}/sports`;
                return
            }

            if (view.includes('future') || view.includes('standard')) {
                CommonUtil.saveLastViewByLoginId(VIEW.STANDARD);
                if(window.env.isB2B){
                    window.location.href = CommonUtil.getB2BEuroViewURL(currentLanguage);
                } else {
                window.location.href = CommonUtil.getEuroViewURL(currentLanguage);
                }
                return
            }
            if (view.includes('classic')) {
                CommonUtil.saveLastViewByLoginId(VIEW.CLASSIC);
                window.location.href = `/${currentLanguage}${AccountAction.getViewPath(VIEW.CLASSIC)}/sports`
                return
            }
            if (view.includes('europe')) {
                CommonUtil.saveLastViewByLoginId(VIEW.EUROPE);
                window.location.href = `/${currentLanguage}${AccountAction.getViewPath(VIEW.EUROPE)}/sports`
                return
        }
    }

    }

    static getRegionalMenusContent(view, selectedIcon) {
        const selectedIconClass = `${selectedIcon ? 'fal fa-check' : ''}  fas menu-item-icon`
        switch (view.value) {
            case ViewKeys.asia:
                return (<React.Fragment>
                    { !CommonUtil.isB2BWhitelabel() &&<i id="i_region_asian" className={selectedIconClass}></i> }
                    <span key='region_asian' id='region_asian'>{this.translate(view.title)}</span>
                </React.Fragment>);
            case ViewKeys.compact:
                return (<React.Fragment>
                    { !CommonUtil.isB2BWhitelabel() && <i id="i_region_compact" className={selectedIconClass}></i>}
                    <span key='region_compact' id='region_compact'>{this.translate(view.title)}</span>
                </React.Fragment>);
            case ViewKeys.standard:
                return (
                    <React.Fragment>
                        {!CommonUtil.isB2BWhitelabel() && <i id="i_region_future" className={selectedIconClass}></i>}
                        <span key='region_future' id='region_future'>{this.translate(view.title)}</span>
                    </React.Fragment>);
            case ViewKeys.classic:
                return (<React.Fragment>
                    <i id="i_region_classic" className={selectedIconClass}></i>
                    <span key='region_classic' id='region_classic'>{this.translate(view.title)}</span>
                </React.Fragment>);
            case ViewKeys.europe:
                return(
                    <React.Fragment>
                        {!window.env.isB2B && <i id="i_region_europe" className={selectedIconClass}></i>}
                        <span key='region_europe' id='region_europe'>{this.translate(view.title)}</span>
                    </React.Fragment>
                )
            default:
                return null;
        }
    }

    static getRegionalMenuItems(viewSupports, currentViewContainer, menuHeaderContent) {
      const availableViews = CommonUtil.getAvailableViews();
      const menuItems = viewSupports
        .filter(view => availableViews[view.value])
        .map(view => {
          const selectedIcon = menuHeaderContent && view.value === currentViewContainer
          const content = SettingActions.getRegionalMenusContent(view, selectedIcon);
          return {
            content: content,
            link: "",
            handle: SettingActions.handleChangeRegional,
            itemId: "a_region_" + view.value,
            className: view.value === currentViewContainer ? 'selected' : ''
          } 
      });

      return menuHeaderContent 
        ? [menuHeaderContent, ...menuItems]
        : menuItems;
    }

    static getLocaleTitle(locale) {
        return _.upperCase(_.replace(locale, '-', ' '));
    }

    static getLocaleMenuItems(langSupports, handleChangeLocale, menuHeaderContent) {
        const listMenuItems = [];
        if (menuHeaderContent) {
            listMenuItems.push(menuHeaderContent);
        }

        _.forEach(langSupports, item => {
            const key = CommonUtil.localeCodeToLanguageCode(item)
            const selectedIconClass = `${key === CommonUtil.getCurrentLang() ? 'fal fa-check' : ''}  menu-item-icon`
            const isB2B = window.env.isB2B;
            const languageText = CommonUtil.isPA() && key === 'hy' ? this.translate(`${key}_PA`) : this.translate(key);
            listMenuItems.push({
                content: (<React.Fragment>
                            { !CommonUtil.isB2BWhitelabel() && <i id={"i_lang_"+ key} className={selectedIconClass}></i>}
                            <span key={'spanlang_' + key} id={key}>
                                {languageText}{isB2B ? ` - ${this.getLocaleTitle(key)}` : ''}
                            </span>
                        </React.Fragment>
                ),
                link: "",
                handle: handleChangeLocale,
                itemId: 'alang_' + key,
                className: key === CommonUtil.getCurrentLang() ? 'selected' : ''
            })
        })
        return listMenuItems;
    }
}


// WEBPACK FOOTER //
// ./src/app/actions/SettingActions.js